import type { IBasicInfoRow } from '@/Services/CampaignManagement/LineItemSummary.service';
import { Box, Button, Dialog, Paper, TableContainer } from '@mui/material';
import InfoTable from './InfoTable';

interface IProps {
  open: boolean;
  onClose: () => void;
  rows: IBasicInfoRow[];
  caption: string;
}

const InfoTableModal = ({ open, onClose, rows, caption }: IProps) => {
  return (
    <Dialog maxWidth={false} open={open} onClose={onClose}>
      <TableContainer component={Paper} sx={{ overflowX: 'hidden', overflowY: 'auto', padding: '16px' }}>
        <InfoTable rows={rows} caption={caption} />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
          <Button variant='contained' onClick={onClose}>
            Close
          </Button>
        </Box>
      </TableContainer>
    </Dialog>
  );
};

export default InfoTableModal;
